import { DateUtils } from '@web_opxp/features';
import { BANNER_VISIBILITY_TIMEOUT_S } from './constants';

export function loadBannerTimestamp(userId?: number) {
  if (!userId) {
    return undefined;
  }
  const state = localStorage.getItem(`${userId}-restore-banner`);
  return state === null ? undefined : Number(state);
}

export function canShowBanner(userId?: number) {
  const savedTimestamp = loadBannerTimestamp(userId);
  if (!savedTimestamp) {
    // if no previous timestamp was saved - show banner
    return true;
  }
  const current = DateUtils.getUnixTimestamp();
  // if more time has passed then defined in the threshold - show banner
  return current - savedTimestamp > BANNER_VISIBILITY_TIMEOUT_S;
}

export function saveBannerTimestamp(userId?: number) {
  if (!userId) {
    return;
  }
  const timestamp = DateUtils.getUnixTimestamp();
  try {
    localStorage.setItem(`${userId}-restore-banner`, `${timestamp}`);
  } catch (error) {
    // ignore error if saving has failed
  }
}
